//  ______                        _               _  _  _
//  |  _  \                      | |             | |(_)| |
//  | | | |  ___    _ __    ___  | |_    ___   __| | _ | |_
//  | | | | / _ \  | '_ \  / _ \ | __|  / _ \ / _` || || __|
//  | |/ / | (_) | | | | || (_) || |_  |  __/| (_| || || |_
//  |___/   \___/  |_| |_| \___/  \__|  \___| \__,_||_| \__|
//
// Generated by skir-typescript-gen
// Home: https://github.com/gepheum/skir-typescript-gen
//
// To install the Skir client library:
//   npm i skir-client

/// <reference types="./calendar.d.ts" />

import * as $ from "skir-client";
import * as x_calendar_extractions_skir from "./calendar_extractions.js";

// -----------------------------------------------------------------------------
// enum CalendarEventInfo.Source
// -----------------------------------------------------------------------------

/**
 * Deeply immutable.
 *
 * @alias CalendarEventInfo.Source
 */
class CalendarEventInfo_Source extends $._EnumBase {}

// -----------------------------------------------------------------------------
// struct CalendarEventInfo.Attendee
// -----------------------------------------------------------------------------

/**
 * Deeply immutable. If you need mutability, use `CalendarEventInfo.Attendee.Mutable`.
 *
 * @alias CalendarEventInfo.Attendee
 */
class CalendarEventInfo_Attendee extends $._FrozenBase {}

function initCalendarEventInfo_Attendee(target, initializer) {
  target.email = initializer.email ?? "";
  target.organizer = initializer.organizer ?? false;
  target.isUser = initializer.isUser ?? false;
  target.declined = initializer.declined ?? false;
  target.displayName = initializer.displayName ?? "";
}

// -----------------------------------------------------------------------------
// struct CalendarEventInfo
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CalendarEventInfo.Mutable`. */
export class CalendarEventInfo extends $._FrozenBase {}

function initCalendarEventInfo(target, initializer) {
  target.eventId = initializer.eventId ?? "";
  target.source = CalendarEventInfo_Source.create(initializer.source ?? CalendarEventInfo_Source.UNKNOWN);
  target.syncTime = initializer.syncTime ?? $.Timestamp.UNIX_EPOCH;
  target.userId = initializer.userId ?? "";
  target.name = initializer.name ?? "";
  target.descriptionHtml = initializer.descriptionHtml ?? "";
  target.startTime = initializer.startTime ?? $.Timestamp.UNIX_EPOCH;
  target.endTime = initializer.endTime ?? $.Timestamp.UNIX_EPOCH;
  target.htmlLink = initializer.htmlLink ?? "";
  target.attendees = $._toFrozenArray(
    initializer.attendees || [],
    CalendarEventInfo_Attendee.create,
  );
  target.callUrl = initializer.callUrl ?? "";
  target.declined = initializer.declined ?? false;
  target.isInternal = initializer.isInternal ?? false;
  target.crmAccountName = initializer.crmAccountName ?? "";
  target.crmAccountId = initializer.crmAccountId ?? null;
  target.crmAccountDomain = initializer.crmAccountDomain ?? "";
  target.linkedOpportunityId = initializer.linkedOpportunityId ?? null;
  target.recurringEventId = initializer.recurringEventId ?? "";
  target.originalStartTime = initializer.originalStartTime ?? null;
  target.revision = initializer.revision ?? "";
  target.organizerEmail = initializer.organizerEmail ?? "";
}

// -----------------------------------------------------------------------------
// struct CalendarEventEdits
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CalendarEventEdits.Mutable`. */
export class CalendarEventEdits extends $._FrozenBase {}

function initCalendarEventEdits(target, initializer) {
  target.botInvited = initializer.botInvited ?? false;
  target.isPrivate = initializer.isPrivate ?? false;
  target.botInvitedByUserId = initializer.botInvitedByUserId ?? "";
  target.botInvitedAt = initializer.botInvitedAt ?? null;
  target.recordingOptedOutUserIds = $._toFrozenArray(
    initializer.recordingOptedOutUserIds || []);
    target.isPrivateExplicit = initializer.isPrivateExplicit ?? false;
}

// -----------------------------------------------------------------------------
// struct CalendarEventOwnership
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CalendarEventOwnership.Mutable`. */
export class CalendarEventOwnership extends $._FrozenBase {}

function initCalendarEventOwnership(target, initializer) {
  target.ownerUserId = initializer.ownerUserId ?? "";
  target.hasRecording = initializer.hasRecording ?? false;
}

// -----------------------------------------------------------------------------
// struct CalendarEvent
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `CalendarEvent.Mutable`. */
export class CalendarEvent extends $._FrozenBase {}

function initCalendarEvent(target, initializer) {
  target.info = CalendarEventInfo.create(initializer.info ?? CalendarEventInfo.DEFAULT);
  target.edits = CalendarEventEdits.create(initializer.edits ?? CalendarEventEdits.DEFAULT);
  target.extractions = x_calendar_extractions_skir.CalendarEventExtractions.create(initializer.extractions ?? x_calendar_extractions_skir.CalendarEventExtractions.DEFAULT);
  target.ownership = initializer.ownership ? CalendarEventOwnership.create(initializer.ownership) : null;
  target.recordingBlockedByRule = initializer.recordingBlockedByRule ?? "";
}

// -----------------------------------------------------------------------------
// struct UserCalendarEvents
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `UserCalendarEvents.Mutable`. */
export class UserCalendarEvents extends $._FrozenBase {}

function initUserCalendarEvents(target, initializer) {
  target.userId = initializer.userId ?? "";
  target.syncTime = initializer.syncTime ?? $.Timestamp.UNIX_EPOCH;
  target.events = $._toFrozenArray(
    initializer.events || [],
    CalendarEventInfo.create,
  );
}

// -----------------------------------------------------------------------------
// struct GoogleUserToken
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `GoogleUserToken.Mutable`. */
export class GoogleUserToken extends $._FrozenBase {}

function initGoogleUserToken(target, initializer) {
  target.userId = initializer.userId ?? "";
  target.refreshToken = initializer.refreshToken ?? "";
  target.accessToken = initializer.accessToken ?? "";
  target.tokenExpiry = initializer.tokenExpiry ?? $.Timestamp.UNIX_EPOCH;
}

// -----------------------------------------------------------------------------
// struct GoogleUser
// -----------------------------------------------------------------------------

/** Deeply immutable. If you need mutability, use `GoogleUser.Mutable`. */
export class GoogleUser extends $._FrozenBase {}

function initGoogleUser(target, initializer) {
  target.userId = initializer.userId ?? "";
  target.hasToken = initializer.hasToken ?? false;
}

// -----------------------------------------------------------------------------
// Initialize the serializers
// -----------------------------------------------------------------------------

$._initModuleClasses(
  "calendar.skir",
  [
    {
      kind: "enum",
      ctor: CalendarEventInfo_Source,
      name: "Source",
      parentCtor: CalendarEventInfo,
      variants: [
        {
          name: "UNKNOWN",
          number: 0,
        },
        {
          name: "GOOGLE_CALENDAR",
          number: 1,
        },
        {
          name: "MICROSOFT_CALENDAR",
          number: 2,
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventInfo_Attendee,
      initFn: initCalendarEventInfo_Attendee,
      name: "Attendee",
      parentCtor: CalendarEventInfo,
      fields: [
        {
          name: "email",
          property: "email",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "organizer",
          property: "organizer",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "is_user",
          property: "isUser",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "declined",
          property: "declined",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "display_name",
          property: "displayName",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventInfo,
      initFn: initCalendarEventInfo,
      name: "CalendarEventInfo",
      fields: [
        {
          name: "event_id",
          property: "eventId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "source",
          property: "source",
          number: 1,
          type: {
            kind: "record",
            ctor: CalendarEventInfo_Source,
          },
        },
        {
          name: "sync_time",
          property: "syncTime",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "user_id",
          property: "userId",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "name",
          property: "name",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "description_html",
          property: "descriptionHtml",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "start_time",
          property: "startTime",
          number: 6,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "end_time",
          property: "endTime",
          number: 7,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "html_link",
          property: "htmlLink",
          number: 8,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "attendees",
          property: "attendees",
          number: 9,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CalendarEventInfo_Attendee,
            },
          },
          mutableGetter: "mutableAttendees",
        },
        {
          name: "call_url",
          property: "callUrl",
          number: 10,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "declined",
          property: "declined",
          number: 11,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "is_internal",
          property: "isInternal",
          number: 12,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "crm_account_name",
          property: "crmAccountName",
          number: 13,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "crm_account_id",
          property: "crmAccountId",
          number: 14,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int64",
            },
          },
        },
        {
          name: "crm_account_domain",
          property: "crmAccountDomain",
          number: 15,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "linked_opportunity_id",
          property: "linkedOpportunityId",
          number: 16,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "int64",
            },
          },
        },
        {
          name: "recurring_event_id",
          property: "recurringEventId",
          number: 17,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "original_start_time",
          property: "originalStartTime",
          number: 18,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "revision",
          property: "revision",
          number: 19,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "organizer_email",
          property: "organizerEmail",
          number: 20,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventEdits,
      initFn: initCalendarEventEdits,
      name: "CalendarEventEdits",
      fields: [
        {
          name: "bot_invited",
          property: "botInvited",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "is_private",
          property: "isPrivate",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
        {
          name: "bot_invited_by_user_id",
          property: "botInvitedByUserId",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "bot_invited_at",
          property: "botInvitedAt",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "primitive",
              primitive: "timestamp",
            },
          },
        },
        {
          name: "recording_opted_out_user_ids",
          property: "recordingOptedOutUserIds",
          number: 4,
          type: {
            kind: "array",
            item: {
              kind: "primitive",
              primitive: "string",
            },
          },
          mutableGetter: "mutableRecordingOptedOutUserIds",
        },
        {
          name: "is_private_explicit",
          property: "isPrivateExplicit",
          number: 5,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEventOwnership,
      initFn: initCalendarEventOwnership,
      name: "CalendarEventOwnership",
      fields: [
        {
          name: "owner_user_id",
          property: "ownerUserId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "has_recording",
          property: "hasRecording",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: CalendarEvent,
      initFn: initCalendarEvent,
      name: "CalendarEvent",
      fields: [
        {
          name: "info",
          property: "info",
          number: 0,
          type: {
            kind: "record",
            ctor: CalendarEventInfo,
          },
          mutableGetter: "mutableInfo",
        },
        {
          name: "edits",
          property: "edits",
          number: 1,
          type: {
            kind: "record",
            ctor: CalendarEventEdits,
          },
          mutableGetter: "mutableEdits",
        },
        {
          name: "extractions",
          property: "extractions",
          number: 2,
          type: {
            kind: "record",
            ctor: x_calendar_extractions_skir.CalendarEventExtractions,
          },
          mutableGetter: "mutableExtractions",
        },
        {
          name: "ownership",
          property: "ownership",
          number: 3,
          type: {
            kind: "optional",
            other: {
              kind: "record",
              ctor: CalendarEventOwnership,
            },
          },
        },
        {
          name: "recording_blocked_by_rule",
          property: "recordingBlockedByRule",
          number: 4,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: UserCalendarEvents,
      initFn: initUserCalendarEvents,
      name: "UserCalendarEvents",
      fields: [
        {
          name: "user_id",
          property: "userId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "sync_time",
          property: "syncTime",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
        {
          name: "events",
          property: "events",
          number: 2,
          type: {
            kind: "array",
            item: {
              kind: "record",
              ctor: CalendarEventInfo,
            },
          },
          mutableGetter: "mutableEvents",
        },
      ],
    },
    {
      kind: "struct",
      ctor: GoogleUserToken,
      initFn: initGoogleUserToken,
      name: "GoogleUserToken",
      fields: [
        {
          name: "user_id",
          property: "userId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "refresh_token",
          property: "refreshToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "access_token",
          property: "accessToken",
          number: 2,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "token_expiry",
          property: "tokenExpiry",
          number: 3,
          type: {
            kind: "primitive",
            primitive: "timestamp",
          },
        },
      ],
    },
    {
      kind: "struct",
      ctor: GoogleUser,
      initFn: initGoogleUser,
      name: "GoogleUser",
      fields: [
        {
          name: "user_id",
          property: "userId",
          number: 0,
          type: {
            kind: "primitive",
            primitive: "string",
          },
        },
        {
          name: "has_token",
          property: "hasToken",
          number: 1,
          type: {
            kind: "primitive",
            primitive: "bool",
          },
        },
      ],
    },
  ]
);
